<template>
  <div class="wrapper">
    <Progress
      class="ts-progress"
      :stroke-width="16"
      :show-text="false"
      :percentage="percentage"
      v-bind="$attrs"
      v-on="$listeners"
    />
    <div class="text" v-if="labeled">{{ Math.round(percentage) }} %</div>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
}
.ts-progress::v-deep {
  flex-grow: 1;

  .el-progress-bar__outer {
    box-shadow: inset 8px 8px 16px 0 #a6abbd, inset -8px -8px 16px 0 #fafbff;
    border: solid 1px rgba(255, 255, 255, 0.32);
    background-blend-mode: soft-light, normal;
    background-image: linear-gradient(277deg, #000000, #ffffff 0%), linear-gradient(to bottom, #ebecf0, #ebecf0);

    overflow: visible;

    .el-progress-bar__inner {
      box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
      border: solid 2px rgba(255, 255, 255, 0.32);
      background-blend-mode: normal, soft-light, normal;
      background-image: linear-gradient(to bottom, #99ffd1, #99ffd1), linear-gradient(281deg, #000000 100%, #ffffff 0%),
        linear-gradient(to bottom, #ebecf0, #ebecf0);

      box-sizing: border-box;
      background-color: #99ffd1;
    }
  }
}

.text {
  font-family: Roboto;
  font-size: 12px;
  line-height: 1.5;
  color: #6d7587;

  margin-left: 12px;
}
</style>

<script>
import { Progress } from 'element-ui';

export default {
  name: 'TsProgress',
  components: {
    Progress
  },
  props: {
    labeled: {
      type: Boolean,
      default: true
    },
    percentage: {
      type: Number,
      default: 0,
      required: true
    }
  }
};
</script>
